export default __webpack_public_path__ + "static/esso_3_box-ccfad7652f8be9d88a6756569530ce12.png";